import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AccessGate } from "./components/AccessGate";
import "./app.css";
// Keep the shared site system last: it owns the StoryOS shell and deliberately
// themes page-local explanatory CSS without changing embedded product surfaces.
import "./site-system.css";
import "./access-gate.css";
const root = document.getElementById("root");
if (!root) {
    throw new Error("Feed Lab root element was not found");
}
createRoot(root).render(_jsx(StrictMode, { children: _jsx(AccessGate, { children: _jsx(App, {}) }) }));
